/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_PlaceholderInputs */

const en_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your password`)
};

const de_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort eingeben`)
};

const fr_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre ton mot de passe`)
};

const es_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese su contraseña`)
};

const it_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci la tua password`)
};

const nl_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer je wachtwoord in`)
};

const pl_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podaj swoje hasło`)
};

const fi_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syötä salasanasi`)
};

const da_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast din adgangskode`)
};

const sv_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange ditt lösenord`)
};

/**
* | output |
* | --- |
* | "Enter your password" |
*
* @param {Auth_Password_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_password_placeholder = /** @type {((inputs?: Auth_Password_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_password_placeholder(inputs)
	if (locale === "fr") return fr_auth_password_placeholder(inputs)
	if (locale === "es") return es_auth_password_placeholder(inputs)
	if (locale === "it") return it_auth_password_placeholder(inputs)
	if (locale === "nl") return nl_auth_password_placeholder(inputs)
	if (locale === "pl") return pl_auth_password_placeholder(inputs)
	if (locale === "fi") return fi_auth_password_placeholder(inputs)
	if (locale === "da") return da_auth_password_placeholder(inputs)
	if (locale === "sv") return sv_auth_password_placeholder(inputs)
	return en_auth_password_placeholder(inputs)
});